import React from 'react';
import { DataGridButton, IColumnType, IDataType, SisDataGridColumns } from '../../components/table';

export const Columns = (handleEdit, translate): SisDataGridColumns => [
  {
    dataType: IDataType.number,
    dataField: 'id',
    width: '5%',
    caption: 'Customer id',
  },
  {
    dataType: IDataType.string,
    dataField: 'name',
    width: '20%',
    caption: 'Name',
  },
  {
    dataType: IDataType.string,
    dataField: 'emailInboxArr',
    width: '68%',
    caption: 'E-mail inbox',
  },

  {
    dataField: 'visible',
    dataType: IDataType.boolean,
    caption: 'Visible',
    width: '7%',
  },
  {
    type: IColumnType.buttons,
    cellRender: (data) => ButtonCell(data, handleEdit, translate),
    width: '8%',
  },
];

const ButtonCell = (cellData, handleEdit, translate) => {
  return (
    <DataGridButton
      hint={translate!('Edit', '')}
      icon="edit"
      cellData={cellData}
      onClick={() => handleEdit(cellData)}
    />
  );
};
